import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).init({
    // we init with resources

    resources: {
        en: {
            translations: {
                Relog: 'Relog',
                AllRequests: 'All requests',
                Kazpensia: 'Kazpensia',
                NewCouriers: 'New couriers',
                OrdersByStatuses: 'Orders by statuses',
                Reports: 'Reports',
                UsersAndRoles: 'Users and roles',
                Dictionaries: 'Dictionaries',
                Regions: 'Regions',
                Branches: 'Branches',
                Statuses: 'Statuses',
                NPO: 'NPO',
                PaymentDetails: 'Payment details',
                Actions: 'Actions',
                SystemSettings: 'System settings',
                Users: 'Users',
                Roles: 'Roles',
                AccessRights: 'Access rights',
                CourierSummary: 'Courier summary',
                SituationCenter: 'Situation center',
                CouriersMap: 'Couriers map',
                EmcTypes: 'EMC types',
                RejectReasons: 'Reject reasons',
                WorkingDays: 'Working days',
                Flights: 'Flights',
                Confirmations: 'Confirmations',
                Activations: 'Activations',
                Confirmed: 'Confirmed',
                FreelanceCouriers: 'Freelance Couriers',
                ByStatus: 'By statuses',
                CourierCall: 'Courier call',
            },
        },
        ru: {
            translations: {
                Relog: 'Relog',
                AllRequests: 'Все заявки',
                Kazpensia: 'Казпенсия',
                NewCouriers: 'Новые курьеры',
                OrdersByStatuses: 'Заявки по статусам',
                Reports: 'Отчеты',
                UsersAndRoles: 'Пользователи и роли',
                Dictionaries: 'Справочники',
                Regions: 'Регионы',
                Branches: 'Филиалы',
                Statuses: 'Статусы',
                NPO: 'Выдача НПО',
                PaymentDetails: 'Детали платежей',
                Actions: 'Действии',
                SystemSettings: 'Системные настройки',
                Users: 'Пользователи',
                Roles: 'Роли',
                AccessRights: 'Права доступа',
                CourierSummary: 'Сводка курьеров',
                SituationCenter: 'Ситуационный центр',
                CouriersMap: 'Карта курьеров',
                EmcTypes: 'Типы EMC',
                RejectReasons: 'Причины невручения',
                WorkingDays: 'Рабочие дни по КП',
                Flights: 'Рейсы',
                Confirmations: 'На подтверждении',
                Activations: 'На активации',
                Confirmed: 'Подтвержден',
                FreelanceCouriers: 'Внештатные курьеры',
                ByStatus: 'По статусам',
                CourierCall: 'Вызов курьера',
            },
        },
        kk: {
            translations: {
                Relog: 'Relog',
                AllRequests: 'Все заявки',
                Kazpensia: 'Казпенсия',
                NewCouriers: 'Новые курьеры',
                OrdersByStatuses: 'Заявки по статусам',
                Reports: 'Отчеты',
                UsersAndRoles: 'Пользователи и роли',
                Dictionaries: 'Справочники',
                Regions: 'Регионы',
                Branches: 'Филиалы',
                Statuses: 'Статусы',
                NPO: 'Выдача НПО',
                PaymentDetails: 'Детали платежей',
                Actions: 'Действии',
                SystemSettings: 'Системные настройки',
                Users: 'Пользователи',
                Roles: 'Роли',
                AccessRights: 'Права доступа',
                CourierSummary: 'Сводка курьеров',
                SituationCenter: 'Ситуационный центр',
                CouriersMap: 'Карта курьеров',
                EmcTypes: 'Типы EMC',
                RejectReasons: 'Причины невручения',
                WorkingDays: 'Рабочие дни по КП',
                Flights: 'Рейсы',
                Confirmations: 'На подтверждении',
                Activations: 'На активации',
                Confirmed: 'Подтвержден',
                FreelanceCouriers: 'Внештатные курьеры',
                ByStatus: 'По статусам',
                CourierCall: 'Вызов курьера',
            },
        },
    },
    fallbackLng: 'ru',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ',',
    },

    react: {
        wait: true,
    },
});

export default i18n;
